module.exports = __webpack_public_path__ + "img/kp.2f6d9c15.svg";